

export const OidcSettings = {

    authority: window._env_.REACT_APP_SSO_URL,
    client_id: window._env_.REACT_APP_CLIENT_ID,
    redirect_uri: window._env_.REACT_APP_GUI_URL+"signin-oidc",
    response_type: 'id_token token',
    scope:  'openid',
    monitorSession: false,
    silent_redirect_uri:window._env_.REACT_APP_GUI_URL+"silentRenewFrame.html",
    automaticSilentRenew:true,
    extraQueryParams:{checkLoginIframe:false},
    accessTokenExpiringNotificationTime:window._env_.REACT_APP_TOKEN_REFRESHTIME,
    post_logout_redirect_uri:window._env_.REACT_APP_GUI_URL+"logout/callback",
    webAuthResponseType:'id_token token',

};

export const  METADATA_OIDC = {
    issuer: window._env_.REACT_APP_SSO_URL,
    jwks_uri: window._env_.REACT_APP_SSO_URL + "/protocol/openid-connect/certs",
    authorization_endpoint: window._env_.REACT_APP_SSO_URL + "/protocol/openid-connect/auth",
    token_endpoint: window._env_.REACT_APP_SSO_URL + "/protocol/openid-connect/token",
    userinfo_endpoint: window._env_.REACT_APP_SSO_URL + "/protocol/openid-connect/userinfo",
    end_session_endpoint: window._env_.REACT_APP_SSO_URL + "/protocol/openid-connect/logout",
    check_session_iframe: window._env_.REACT_APP_SSO_URL + "/protocol/openid-connect/login-status-iframe.html",
    introspection_endpoint: window._env_.REACT_APP_SSO_URL + "/protocol/openid-connect/token/introspect"
};
